module.exports = __webpack_public_path__ + "img/partner-bg.9223b1c4.webp";